import ReactDOM from 'react-dom';
import ErrorManager from "./ErrorManager";
import User from './User';


class Core 
{
    static Instance = new Core();
    //static Address = "http://localhost:8080/";
    static Address = "https://www.weeflow-figest.ovh/api/";
    constructor()
    {
        this.isLoading = false;
        this.loadingCounter = 0;
        this.user = User.Load();  

        this.OnSignIn = this.OnSignIn.bind(this);
        this.OnSignOut = this.OnSignOut.bind(this);
        this.Request = this.Request.bind(this);
    }

    OnSignIn(googleUser)
    {
        if(googleUser.getAuthResponse == null)
            return;
        User.Create(googleUser).then((user) => {
            this.user = user;
            this.user.Save();
            window.location.href = "/search";
        })
    }

    OnSignOut(googleUser)
    {
        this.user = User.Erase();
        window.location.href = "/login";
    }
    
    CheckForm(compo)
    {
        let node = ReactDOM.findDOMNode(compo);
        let nodes = node.querySelectorAll("input,textarea,select");
        let valid = true;
        for(var n in nodes)
        {
            n = nodes[n];
            if(n.checkValidity == null)
                continue;
            n.classList.add("checked");
            if(!n.checkValidity())
                valid = false;
        }
        if(valid == false)
            return false;
        return true;
    }


    ShowLoading()
    {
        this.loadingCounter++;
        if(this.isLoading)
            return;
        this.isLoading = true;
        var e = document.createElement("div");
        e.id = "loading";
        document.body.appendChild(e);
    }

    HideLoading()
    {
        if(!this.isLoading)
            return;
        this.loadingCounter--;
        if(this.loadingCounter > 0)
        {
            return;
        }
        else
        {
            this.loadingCounter = 0;
            this.isLoading = false;
        }
        var e = document.getElementById("loading");

        if(e == null)
            return;
        e.remove();
    }


    GoBackWithRefresh() {
        if ('referrer' in document) {
            window.location = document.referrer;
            /* OR */
            //location.replace(document.referrer);
        } else {
            window.history.back();
        }
    }

    Request(address, data, method = "POST")
    {
        return new Promise((resolve, reject) =>
        {
            //Core.Instance.ShowLoading();

                if(data == null)
                    data = {};

                let options = {
                    method: method,
                    mode: "cors",
                };

                if(method != "GET" && method != "HEAD" && address.indexOf(Core.Address) != -1)
                {
                    if(data instanceof FormData){
                        options.body = data;
                    }else{
                        options.headers =  { 
                            'Content-Type': 'application/json', 
                        };
                        options.body = JSON.stringify(data);
                    }
                }
                else if(method != "GET" && method != "HEAD")
                {
                    options.body = new FormData();
                    let props = Object.getOwnPropertyNames(data);
                    for(let i in props)
                    {
                        let name = props[i];
                        let value = data[name];
                        options.body.append(name, value);
                    }
                    options.mode = "cors";

                }

                if(address.indexOf(Core.Address) != -1)
                {
                    let token = this.user != null ? this.user.token : null;
                    
                    if(options.headers == null)
                        options.headers =  { 'X-Authorization': "Token "+token };
                    else 
                        options.headers['X-Authorization'] = "Token "+token;
                }

                var request = fetch(address, options);
                request.then(async (response) =>{
                    const text = await response.text();
                    try{
                      const json = JSON.parse(text)
                      return json;
                    } catch(err) {
                      throw new Error("Did not receive JSON, instead received: " + text);
                    }
                }).then((json) => {
                    Core.Instance.HideLoading();
                    if(json.error != null && json.error.code != 204 && json.error.code != 403)
                    {
                        reject(json);
                        // throw new Error(JSON.stringify(json));
                    }
                    else if(json.error != null && json.error.code == 204)
                    {
                        resolve(null);
                    }
                    resolve(json);  
                }, (error) => {
                    Core.Instance.HideLoading();
                    reject(error);
                    if(JSON.stringify(error) !== "{}"){
                        throw new Error(JSON.stringify(error));
                    }
                });
                request.catch(function(error){
                    Core.Instance.HideLoading();
                    reject(error);
                    throw new Error(JSON.stringify(error));
                });
        });
    }
}

export default Core;


// WEBPACK FOOTER //
// ./src/Core/Core.js